module.exports = __webpack_public_path__ + "static/media/logo-2.922204a3.png";